/**
 * Card Component
 */

import React, { FC, forwardRef } from 'react';
import { withTheme } from 'styled-components';

import Handler from '../../commonTypes/handler.types';
import bindHandlers from '../../utils/handlerHelper';

import { CardProps, Elevation } from './card.types';
import { Wrapper } from './card.style';

const Card: FC<CardProps> = forwardRef(({
  elevation = Elevation.SUBTLE,
  handlers = {},
  hideIfEmpty = false,
  children,
  ...otherProps
}: CardProps, ref) => {

  const combinedHandlers: Handler = bindHandlers(null, handlers);

  return (
    <Wrapper
      $elevation={ elevation }
      $hideIfEmpty={ hideIfEmpty }
      ref={ref}
      { ...combinedHandlers }
      { ...otherProps}
    >
      { children }
    </Wrapper>
  );
});

export default withTheme(Card);
